import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
  HostBinding,
  ChangeDetectionStrategy,
  Input,
  Injector,
} from '@angular/core';
import {
  GPU_MEDIA_QUERIES,
  GpuMediaQueryBreakpoints,
} from '@geneplanet/ngx-ui/src/lib/layout';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { IntroId } from '../../enums/intro-id.enum';
import { IntroModalType } from '../../enums/intro-modal-type.enum';
import { SwiperModalStep } from '../../interfaces';
import { IntroModalService } from '../../services/intro-modal.service';

@UntilDestroy()
@Component({
  selector: 'app-swiper-modal',
  templateUrl: './swiper-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwiperModalComponent {
  @HostBinding('class') classAttribute = 'overflow-hidden';
  @ViewChild('container') container: ElementRef;
  @ViewChild('scrollContainer') set height(container: ElementRef) {
    this.minSlideHeight = container?.nativeElement.offsetHeight;
  }

  @Input() introId: IntroId;
  @Input() steps: SwiperModalStep[] = [];
  @Input() confirmButtonText: string;
  @Input() confirmed: boolean;
  @Input() containerClass = 'gpx-0 gpy-sm-72';

  protected isMobile = false;
  protected minSlideHeight = 0;
  protected activePage = 0;

  constructor(
    protected modal: NgbActiveModal,
    private injector: Injector,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe(GPU_MEDIA_QUERIES[GpuMediaQueryBreakpoints.SM_DOWN])
      .pipe(untilDestroyed(this))
      .subscribe((value: BreakpointState) => {
        this.isMobile = value.matches;
        this.cdr.markForCheck();
      });
  }

  get numberOfSlides() {
    return Object.keys(this.steps).length;
  }

  protected onPageChanged(activePage: number) {
    this.activePage = activePage;
  }

  protected close() {
    if (!this.confirmed) {
      this.injector
        .get(IntroModalService)
        .setIntroModalCompleted(this.introId, IntroModalType.SWIPER);
    }
    this.modal.dismiss();
  }

  protected getImgSm(step) {
    const lang = this.translate.currentLang;
    return step[`img-s-${lang}`] ? step[`img-s-${lang}`] : step[`img-s`];
  }

  protected getImgLg(step) {
    const lang = this.translate.currentLang;
    return step[`img-l-${lang}`] ? step[`img-l-${lang}`] : step[`img-l`];
  }
}
